import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, DeviceCertificate } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates, dayjs } from "src/common";
import { Checkbox, InfoPopover } from "src/components";

type AllProps = {
  certificate: DeviceCertificate;
  selected: boolean;
  handleAction: ActionHandlerFunction;
};

function ListRowComponent(props: AllProps) {
  const { certificate, selected, handleAction } = props;
  const expiration_date = dayjs(certificate.expiration_date);
  const [expiration_class, setExpirationClass] = useState<string>("");
  const [popover_message, setPopoverMessage] = useState<string>("");

  useEffect(() => {
    const now = dayjs();
    const one_week_from_now = dayjs().add(1, "week");

    if (expiration_date.isBefore(now)) {
      setExpirationClass("strikethrough-red");
      setPopoverMessage("This certificate has expired.");
    } else if (expiration_date.isAfter(now) && expiration_date.isBefore(one_week_from_now)) {
      setExpirationClass("warning-yellow");
      setPopoverMessage("This certificate will expire soon.");
    } else {
      setExpirationClass("");
      setPopoverMessage("");
    }
  }, []);

  function handleSelect() {
    handleAction({
      actionType: AdminUIActionTypes.Select,
      params: { selected: !selected, certificate },
    });
  }

  return <Row onClick={handleSelect}>
    <Col md="1">
      <Checkbox
        className="sr-only"
        onChange={handleSelect}
        selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
        value="all" label="Select All" />
    </Col>
    <Col md="3" className="col">{certificate.issued_to}</Col>
    <Col md="3">{certificate.issued_by}</Col>
    <Col md="3" className={expiration_class}>
      {certificate.expiration_date}
      {popover_message !== "" && <InfoPopover message={popover_message} />}
    </Col>
    <Col md="2">{certificate.friendly_name}</Col>
  </Row>;
}

export default React.memo(ListRowComponent); 
